import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}/h5/holiday/low-price`;

export const LOW_PRICE_BANNER = `${ROOT}/banner.png`;
export const LOW_PRICE_ARROW_ACTIVE_ICON = `${ROOT}/arrow-active-icon.svg`;
export const LOW_PRICE_ARROW_DEFAULT_ICON = `${ROOT}/arrow-default-icon.svg`;
